export type MaterieelPaneelResponse = {
  logistiekeBenaming: string;
  eenheid: string;
  standaardSnelheid: number;
  snelheidBeperking: string;
  deelpark: string[];
  onderhoudLocatie: string;
  opmerkingen: string | null;
  capaciteitZitplaatsen: number | null;
  capaciteitComfortabel: number | null;
  capaciteitAcceptabel: number;
  capaciteitMaximaal: number | null;
  aantalAssen: number | null;
  lengteBuffers: number;
  massaLeeg: number;
};

export type MaterieelEigenschappen = {
  maxSnelheid: string;
  snelheidBeperking: string;
  massaLeegKg: string;
  lengteOverBuffers: string;
  volNorm: string | null;
  zitPlaatsen: string | null;
  capaciteitAcceptabel: string;
  aantalAssen: number | string;
  deelpark?: string;
  onderhoudLocatie?: string;
  opmerkingen?: string;
} | null;

export function getMaterieelPaneelUrl(eenheidsnummer: string): string {
  return `/materieelpaneel/v1/${eenheidsnummer}`;
}

export function formatNumber(value: string | number | null | undefined, fractionDigits = 0) {
  if (value === null || value === undefined || value === '') return '';
  const number = typeof value === 'string' ? Number(value) : value;
  if (Number.isNaN(number)) return String(value);
  return number.toLocaleString('nl-NL', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function mapMaterieelPaneel(raw: MaterieelPaneelResponse): MaterieelEigenschappen {
  return {
    maxSnelheid: raw.standaardSnelheid ? String(raw.standaardSnelheid) : '',
    snelheidBeperking: raw.snelheidBeperking ? raw.snelheidBeperking : '',
    massaLeegKg: raw.massaLeeg ? String(Math.round(raw.massaLeeg / 1000)) : '',
    lengteOverBuffers: raw.lengteBuffers ? formatNumber(raw.lengteBuffers, 1) : '',
    volNorm: raw.capaciteitMaximaal ? String(raw.capaciteitMaximaal) : '',
    zitPlaatsen: raw.capaciteitZitplaatsen ? String(raw.capaciteitZitplaatsen) : '',
    capaciteitAcceptabel: raw.capaciteitAcceptabel ? String(raw.capaciteitAcceptabel) : '',
    aantalAssen: raw.aantalAssen ? String(raw.aantalAssen) : '',
    deelpark: raw.deelpark.length > 0 ? raw.deelpark.join(', ') : '',
    onderhoudLocatie: raw.onderhoudLocatie ?? '',
    opmerkingen: raw.opmerkingen ?? '',
  };
}
